<template>
  <div class="tableWithPerPageSelection"  v-if="critereRecherche">
    <div class="entete pdb-20px border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('ajoutDevis.ajoutProd', { produit: this.findTypeProduit }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
            <div class="buttons">
              <button class="button btn-modal-annuler" @click="annuler()">
                {{ $t('ajoutDevis.actions.revert')}}
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class='mgt-10px'>
      <div class="columns">
        <div class="column is-narrow mgt-10px">
          <button class="button" @click='changeDate(-1)'>
            <b-icon icon="chevron-left" size="is-small" type="is-default"></b-icon>
          </button>
        </div>
        <div class="column is-narrow mgt-10px">
          <b-datepicker show-week-number icon="calendar-today"
          nearby-selectable-month-days
          v-model="critereRecherche.date.dateDebut"
          :editable="true"
          @input="changementPeriode"
          >
          </b-datepicker>
        </div>
        <div class="column is-narrow mgt-10px">
          <button class="button" @click='changeDate(1)'>
            <b-icon icon="chevron-right" size="is-small" type="is-default"></b-icon>
          </button>
        </div>
        <div class="column has-text-default columns is-marginless
          is-multiline is-vcentered mgt-10px">
          <span
            v-if="briefStocke.produitLocationNum && briefStocke.produitLocationNum.libelle"
            class="column is-12-tablet is-6-fullhd is-paddingless">
            {{$t('ajoutDevis.modeDiffusionPlanning',
            { modeDiffusion: briefStocke.produitLocationNum.libelle
              + ' - ' + briefStocke.produitLocationNum.reference,
            } )}}
          </span>
          <span v-if="briefStocke.dateDebut && briefStocke.dateFin"
            class="column  is-paddingless">
            {{$t('ajoutDevis.datePlanning',
            { dateDebut: dateDebutPlanning,
            dateFin: dateFinPlanning } )}}
            </span>
        </div>
        <div class="column is-narrow level-right">
          <div class="column is-pulled-right pdr-0">
            <parametrage-table class="mgl-10px"
              :reference-table="referenceTable"
              @endLoadParamtre="startArrayRendering = true">
            </parametrage-table>
          </div>
          <div class="column is-pulled-right pdh-0">
            <button class="button" @click='togglePanier()'>
              <b-icon icon="cart-outline" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7" v-if="panier && returnValeurPanier === 0">
                {{$t('ajoutDevis.panier')}}
              </span>
              <span class="is-size-7" v-else>{{returnValeurPanier | formatDevise}}</span>
            </button>
            <div class="info-circle-right background-danger is-pulled-right"
                 v-if="nombrePeriodePanier > 0">
              <span class="inside-circle">{{nombrePeriodePanier}}</span>
            </div>
          </div>

          <div class="column is-pulled-right pdr-0">
            <button class="button" @click='showBrief = !showBrief'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('ajoutDevis.brief')}}</span>
            </button>
            <div class="info-circle-right background-primary is-pulled-right"
                 v-if="nbrBrief">
              <span class="inside-circle">{{nbrBrief}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
    <v-server-table
      class="mgt-10px alignHeaderTab"
      url="" v-if="startArrayRendering && mountedLoadingEnd"
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view :perPage="resultPerPage"
                             @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="societe" slot-scope="props">
        <div class="ellipsis">{{ getLibelleSociete(props.row.supportCommercial.societeId) }}</div>
      </div>
      <div slot="selected" class="has-text-centered" slot-scope="props">
        <a @click="selectionLigne(props.row.id)">
          <b-icon icon="transcribe-close" :class="[{
              'has-text-primary' : produitSelectionne(props.row.id)
            }, {
              'has-text-icon-more' : !produitSelectionne(props.row.id)
            }]" />
        </a>
      </div>
      <template slot='enseignePrincipale' slot-scope='props'>
        <span class="ellipsis">{{ getEnseignePrincipale(props.row) | enseigne }}</span>
      </template>
    </v-server-table>
    </div>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showBrief === true || showPanier === true">
        <brief v-if="showBrief === true"
               @toggleBrief="showBrief = !showBrief"
               :critereRecherche="critereRecherche"
               @viderCritere="critereRecherche = critereRechercheBase"
               @appliquerBrief="appliquerBrief()"/>
        <app-panier
          :canMakeReseauPerso="canMakeReseauPerso"
          @togglePanier="togglePanier()"
          @ajouterAuxLignes="ajouterAuxLignes"
          v-if="showPanier === true"/>
      </div>
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import {
  TEXTS, NO_PER_PAGE_VALUE, SORT_ICON, NO_PAGINATION, RESULTS_PER_PAGE_PLANNING,
} from '@/configuration/clientTableConf';
import * as devisConf from '@/configuration/devisConf';
import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import planningJour from '@/components/planning/c_planningNumeriqueJour';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import * as typesProduitNumerique from '@/store/modules/produitEcranNumerique-mutation-type';
import * as typesCommande from '@/store/modules/commande-mutation-type';
import brief from '@/components/devisCommandes/brief';
import appPanier from '@/components/devisCommandes/panier';
import formatDate from '@/services/general/formatDate';
import messageErreur from '@/services/general/messageErreur';
import formatIsoDate from '@/services/general/formatIsoDate';
import { CATEGORIE_REGROUPEMENT_NUMERIQUE } from '@/configuration/catalogue/produitConf';
import { getAll } from '@/api/produit/produitLocation';
import generatePlanningHeader from '@/services/planningNumerique/headerPlanningNumerique';
import { columnsSplice } from '@/services/general/columns';
import TableItemsInView from '@/components/general/TableItemsInView';
import { ROUTE_ALLOWED_WITHOUT_CLEAN_STORE_FOR_LOGISTIQUE } from '@/configuration/planning/planningConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { REGIE } from '@/configuration/societe/societe';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_PLANNING_AJOUT_NUMERIQUE, REFERENCE_PLANNING_AJOUT_RESEAU_NUMERIQUE } from '@/configuration/general/referenceTableConf';

const permissions = createNamespacedHelpers('permissions');
const produitNumerique = createNamespacedHelpers('produitEcranNumerique');
const Commande = createNamespacedHelpers('commande');
const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  filters: {
    enseigne(data) {
      return data ? `${data.marque}` : '-';
    },
  },
  data() {
    return {
      loadingComponent: null,
      critereRecherche: null,
      selectedAllLigne: false,
      type: devisConf.TYPE_DEVIS,
      permCatalogue: CATALOGUE,
      showBrief: false,
      showPanier: false,
      resultPerPage: RESULTS_PER_PAGE_PLANNING,
      startArrayRendering: false,
      mountedLoadingEnd: false,
    };
  },
  components: {
    AppBreadcrumb,
    brief,
    appPanier,
    TableItemsInView,
    parametrageTable,
  },
  beforeRouteLeave(to, from, next) {
    if (!ROUTE_ALLOWED_WITHOUT_CLEAN_STORE_FOR_LOGISTIQUE.includes(to.name)) {
      // On va vers une route non logique -> on purge le store
      this.clearPanier();
      this.clearBrief();
      this.removeCommande();
    }
    next();
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Commande.mapGetters({
      commandeCourante: 'commande',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...produitNumerique.mapGetters({
      produits: 'produits',
      totalProduits: 'totalProduits',
      criterePlanning: 'criterePlanning',
      briefStocke: 'brief',
      produitSelectionne: 'produitSelectionne',
      panier: 'panier',
    }),
    canMakeReseauPerso() {
      return !(this.commandeCourante.role !== REGIE
        || this.commandeCourante.etat === devisConf.ETAT_COMMANDE_PARTIELLEMENT
        || (this.commandeCourante.type === devisConf.TYPE_COMMANDE
          && (this.commandeCourante.etat === devisConf.ETAT_FACTURE
            || this.commandeCourante.etat === devisConf.ETAT_FACTURE_PARTIELLEMENT)));
    },
    critereRechercheBase() {
      return {
        date: {
          dateDebut: new Date(),
          dateFin: new Date(2019, 0, 31),
        },
        nbHabitants: {
          operateur: null,
          valeur: null,
        },
        agencesId: [],
        libelle: '',
        enseignePrincipale: null,
        enseigneMarque: null,
        villes: null,
        departements: null,
        agglomeration: null,
      };
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    isDevisCommandePartiellement() {
      return this.commandeCourante.etat === devisConf.ETAT_COMMANDE_PARTIELLEMENT;
    },
    iconSelectTotal() {
      if (this.selectedAllLigne) {
        return 'has-text-primary';
      }
      return 'has-text-icon-more';
    },
    dateDebutPlanning() {
      return formatDate(this.briefStocke.dateDebut);
    },
    dateFinPlanning() {
      return formatDate(this.briefStocke.dateFin);
    },
    nombrePeriodePanier() {
      let nombrePeriode = 0;
      Object.values(this.panier).forEach((el) => {
        nombrePeriode += el.periode.length;
      });
      if (nombrePeriode <= 9) {
        return nombrePeriode;
      }
      return '9+';
    },
    ...societe.mapGetters({
      societeActive: 'societeActive',
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    findTypeProduit() {
      return this.$route.params.typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE ? this.$t('ajoutDevis.reseauNum') : this.$t('ajoutDevis.ecranNum');
    },
    returnValeurPanier() {
      let prix = 0;
      Object.values(this.panier).forEach((el) => {
        el.periode.forEach((p) => {
          prix = p.prix + prix;
        });
      });
      return prix;
    },
    breadcrumb() {
      const current = {
        title: this.$i18n.t('ajoutDevis.ajoutProd', { produit: this.findTypeProduit }),
        route: { name: '' },
        isActive: true,
      };
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'breadcrumb')) {
        const output = Array.from(this.$route.params.breadcrumb);
        output[output.length - 1].isActive = false;
        output.push(current);
        return output;
      }
      return [
        current,
      ];
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    referenceTable() {
      return this.$route.params.typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE
        ? REFERENCE_PLANNING_AJOUT_RESEAU_NUMERIQUE : REFERENCE_PLANNING_AJOUT_NUMERIQUE;
    },
    columns() {
      const columns = ['selected', 'enseignePrincipale', 'libelle', 'produitReseauNumerique.adresse.ville', 'entiteCommerciale.audienceAn', 'societe', 'planning'];
      if (this.societesInformations.length === 1 || this.filtrerProduitParSociete
        || this.filtrerProduitParAgence) {
        columnsSplice(columns, 'societe');
      }
      return (this.$route.params.typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE)
        ? columns : columns.filter(c => {
          return !['produitReseauNumerique.adresse.ville', 'enseignePrincipale'].includes(c);
        });
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          'produitReseauNumerique.adresse.ville': this.$i18n.t('catalogue.table.ville'),
          libelle: this.$i18n.t('catalogue.table.label'),
          'entiteCommerciale.audienceAn': this.$i18n.t('catalogue.table.audience'),
          enseignePrincipale: this.$i18n.t('catalogue.table.enseignePrincipale'),
          societe: this.$i18n.t('catalogue.table.societe'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: async () => {
                    await this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    class: this.iconSelectTotal,
                    icon: 'transcribe-close',
                  },
                }),
              ],
            );
          },
          planning: (h) => {
            return generatePlanningHeader(h,
              this.criterePlanning.dateStart, this.criterePlanning.days,
              this.handleClickColonne.bind(this));
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        templates: {
          planning: planningJour,
        },
        columnsClasses: {
          ...this.columns.reduce((acc, val) => {
            acc[val] = 'sticky';
            return acc;
          }, {}),
          selected: 'colonneSelected sticky',
          'produitReseauNumerique.adresse.ville': 'ellipsis planningTailleColonneVille sticky',
          libelle: 'ellipsis planningTailleColonneLibelle sticky',
          planning: 'planningTailleColonnePlanning blockPlanning sticky',
          'entiteCommerciale.audienceAn': 'planningTailleColonneAudience sticky',
          enseignePrincipale: 'planningTailleEnseignePrincipale ellipsis sticky',
          societe: 'planningTailleColonneSociete ellipsis sticky',
        },
        sortable: ['produitReseauNumerique.adresse.ville', 'libelle', 'entiteCommerciale.audienceAn'],
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.critereRecherche.agencesId.length === 0) {
            this.critereRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) {
            data.query = this.critereRecherche;
            data.query.dateVisualisation = formatIsoDate(this.critereRecherche.date.dateDebut);
          }
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.actionsLoadProduits(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduits,
          };
        }),
      };
    },
    nbrBrief() {
      let nbr = this.briefStocke.produitLocationNum ? 1 : 0;
      nbr += this.briefStocke.dateDebut || this.briefStocke.dateFin ? 1 : 0;
      nbr += this.briefStocke.copieLibelle ? 1 : 0;
      nbr += this.critereRecherche.enseignePrincipale
        && this.critereRecherche.enseignePrincipale.length > 0 ? 1 : 0;
      nbr += this.critereRecherche.enseigneMarque
        && this.critereRecherche.enseigneMarque.length > 0 ? 1 : 0;
      nbr += this.critereRecherche.villes
        && this.critereRecherche.villes.length > 0 ? 1 : 0;
      nbr += this.critereRecherche.departements
      && this.critereRecherche.departements.length > 0 ? 1 : 0;
      nbr += this.critereRecherche.agglomeration
        && this.critereRecherche.agglomeration.length > 0 ? 1 : 0;
      nbr += this.critereRecherche.nbHabitants.valeur ? 1 : 0;
      nbr += this.briefStocke.budgetMax !== null ? 1 : 0;
      nbr += this.critereRecherche.societeId ? 1 : 0;
      nbr += this.briefStocke.libelle ? 1 : 0;
      return nbr <= 9 ? nbr : '+9';
    },
  },
  created() {
    window.addEventListener('resize', this.changementPeriode);
    this.setTypeProduit(this.$route.params.typeProduit);
    this.setIsUpdate(true);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.changementPeriode);
  },
  methods: {
    ...societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    handleClickColonne(param) {
      if (this.briefStocke.produitLocationNum
        && this.briefStocke.toggleSelectionPlanning === false) {
        const dateClicked = param.target.dataset.date;
        this.selectionColonne(dateClicked);
      }
    },
    async updateProduitLocation() {
      const typeProduit = this.$route.params.typeProduit;
      const queryItem = {
        query: {
          numerique: true,
          societeId: this.societeActiveId,
        },
        orderBy: 'ProduitLocation.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      const produitsLocation = (await getAll(queryItem)).data.result.items;
      this.briefStocke.produitLocationNum = produitsLocation.find((loc) => {
        if (typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE) {
          return loc.id === this.societeActive.produitIdDefautRegroupementNumerique;
        }
        return loc.id === this.societeActive.produitIdDefautEcranNumerique;
      });
    },
    getEnseignePrincipale(data) {
      return data.entiteCommerciale.enseignesMarques.find(f => f.enseignePrincipale);
    },
    async appliquerBrief() {
      if (this.briefStocke.dateDebut) {
        this.critereRecherche.date.dateDebut = this.briefStocke.dateDebut;
        await this.changementPeriode();
      }
      this.recherche();
    },
    recherche() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.$refs[this.referenceTable]?.refresh();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        throw (e);
      }
    },
    async selectAll() {
      if (!this.briefStocke.dateDebut || !this.briefStocke.dateFin) {
        messageErreur(this.$i18n, this.$i18n.t('ajoutDevis.messages.aucuneDate'));
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.selectedAllLigne = true;
        const promises = [];
        this.produits.forEach((produit) => {
          promises.push(this.actionsSelectionLigne(produit.id));
        });
        await Promise.all(promises);
        await this.actionsCalculTarifPanier();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    ...produitNumerique.mapActions({
      updatePanierSansSuppression: 'updatePanierSansSuppression',
    }),
    ...produitNumerique.mapMutations({
      setBrief: typesProduitNumerique.SET_BRIEF,
      clearBrief: typesProduitNumerique.CLEAR_BRIEF,
      clearPanier: typesProduitNumerique.CLEAR_PANIER,
      toggleSelectionPlanning: typesProduitNumerique.TOGGLE_SELECTION_PLANNING,
      setIsUpdate: typesProduitNumerique.SET_IS_VIEW_UPDATE,
    }),
    togglePanier() {
      this.showPanier = !this.showPanier;
      this.toggleSelectionPlanning();
    },
    changeDate(sens) {
      if (!this.critereRecherche.date.dateDebut) return;
      this.critereRecherche.date.dateDebut = (moment(this.critereRecherche.date.dateDebut).add(this.criterePlanning.days * sens, 'days')).toDate();
      this.changementPeriode();
    },
    annuler() {
      this.clearBrief();
      this.clearPanier();
      this.$router.go(-1);
    },
    ajouterAuxLignes() {
      this.$router.go(-1);
    },
    ...Commande.mapMutations({
      removeCommande: typesCommande.REMOVE_COMMANDE,
      setCommande: typesCommande.SET_COMMANDE,
    }),
    ...produitNumerique.mapActions({
      actionsLoadProduits: 'loadProduits',
      actionschangeCriterePlanning: 'changeCriterePlanning',
      actionsSelectionLigne: 'selectionLigne',
      actionsCalculTarifPanier: 'calculTarifPanier',
    }),
    ...produitNumerique.mapMutations({
      setTypeProduit: typesProduitNumerique.SET_TYPE_PRODUITS,
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    async selectionColonne(dateClicked) {
      const typeProduit = this.$route.params.typeProduit;
      const produitLocationNum = this.briefStocke.produitLocationNum;
      const promises = [];
      this.produits.forEach((el) => {
        promises.push(this.updatePanierSansSuppression({
          produitId: el.id,
          date: dateClicked,
          libelleProduit: el.libelle,
          produitLocationNum,
          typeProduit,
        }));
      });
      // ici on ajoute un élément par produit
      // donc le lancement en parallele ne pose pas de problème
      await Promise.all(promises);
      await this.actionsCalculTarifPanier();
    },
    async selectionLigne(produitId) {
      if (!this.briefStocke.dateDebut || !this.briefStocke.dateFin) {
        messageErreur(this.$i18n, this.$i18n.t('ajoutDevis.messages.aucuneDate'));
        return;
      }
      // const t0 = performance.now();
      await this.actionsSelectionLigne(produitId);

      await this.actionsCalculTarifPanier();
    },
    async changementPeriode() {
      if (!this.critereRecherche.date.dateDebut) return;
      const newCritere = cloneDeep(this.criterePlanning);
      newCritere.dateStart = moment(this.critereRecherche.date.dateDebut).startOf('day');
      this.critereRecherche.dateVisualisation = formatIsoDate(this.dateDebut);
      await this.actionschangeCriterePlanning(newCritere);
      this.recherche();
    },
  },
  async mounted() {
    this.critereRecherche = cloneDeep(this.critereRechercheBase);
    if (!this.$route.params.breadcrumb) {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.$router.go(-1);
    }
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key]);
      await this.loadSocietes({});
      if (this.commandeCourante.datePremierAffichage) {
        this.critereRecherche.date.dateDebut = cloneDeep(
          this.commandeCourante.datePremierAffichage,
        );
      }
      await this.changementPeriode();
      this.clearBrief();
      if (this.societeActive.produitIdDefautRegroupementNumerique) {
        await this.updateProduitLocation();
      }
      if (!this.briefStocke.produitLocationNum) { this.showBrief = true; }
      if (this.filtrerProduitParAgence) {
        this.critereRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
    if (this.$route.params.typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE) {
      this.setInformationPage(this.$t('pageGescom.planning.reseauNumerique'));
    } else {
      this.setInformationPage(this.$t('pageGescom.planning.ecranNumerique'));
    }
  },
};
</script>
